const T_PREFIX = "auth";

export const emailConfirmPopupTrns = {
  title: `${T_PREFIX}.email-confirm-popup.title`,
  description: `${T_PREFIX}.email-confirm-popup.description`,
  gotItButton: `${T_PREFIX}.email-confirm-popup.got-it-btn`,
};
